<ng-container *ngIf="!enableUpdateBtn">
  <div class="mt-5 w-100 h-100">
    <div class="row justify-content-center">
      <p class="text-center">
        {{
          'PLEASE_ENTER_THE_VERIFICATTION_CODE_SENT_TO_YOUR_PHONE_NUMBER' | translate
        }}
        <strong class="font-weight-bold">{{ phonePrefix }}</strong
        >.
      </p>
    </div>
    <div class="row justify-content-center">
      <ngx-otp-input
        [config]="otpInputConfig"
        (fill)="handleFillEvent($event)"
        (focusout)="validateOtp()"
        #ngxotp
      >
      </ngx-otp-input>
    </div>

    <div class="row justify-content-center">
      <p class="pt-3">
        {{ 'DID_NOT_RECIEVE_ACODE' | translate }}
        <a
          href="javascript:void(0);"
          class="verification-link pointer-cursor"
          (click)="sendCode()"
          >{{ 'RESEND_CODE' | translate }}</a
        >
      </p>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="enableUpdateBtn">
  <div class="account-setting-complete modal-main">
    <div class="header row py-4">
      <div
        class="w-100 d-flex flex-row justify-content-center align-items-center"
      >
        <img
          src="/assets/svg/ico-completed-check.svg"
          alt="completed account setting"
          class="completed"
        />
      </div>

      <div
        class="modal-title w-100 d-flex flex-row justify-content-center align-items-center position-relative"
      >
        <p>{{ 'PHONE_VERIFIED' | translate }}</p>
      </div>
    </div>
  </div>
</ng-container>
